<template>
  <el-dialog
    :visible.sync="visibleInterno"
    :width="dialogWidth"
    :close-on-click-modal="false"
    :show-close="true"
    center
    custom-class="popup-informativo-dialog"
    @close="fechar"
  >
    <div slot="title" class="text-center">
      <strong>{{
        popup && popup.titulo ? popup.titulo : "Informações"
      }}</strong>
    </div>

    <div class="popup-body">
      <div v-if="popup" v-html="htmlRenderizado"></div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="fechar">Fechar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "PopupInformativo",

  data() {
    return {
      popup: null,
      visibleInterno: false,
    };
  },

  mounted() {
    this.iniciarPopup();
  },

  computed: {
    dialogWidth() {
      return window.innerWidth <= 768 ? "94%" : "700px";
    },

    htmlRenderizado() {
      if (!this.popup || !this.popup.html) return "";

      var html = this.popup.html;

      if (this.popup.imagem_url) {
        html = html.replace(/{{imagem_url}}/g, this.popup.imagem_url);
      }

      return html;
    },
  },

  methods: {
    getSetDB() {
      return "dbprincipal";
    },

    getTipoUsuario() {
      var usuario = this.$cookies.get("usuario");

      if (usuario) return 3; // RH
      return 2; // Gestão
    },

    async iniciarPopup() {
      try {
        var setDB = this.getSetDB();

        if (!setDB) return;

        var tipo = this.getTipoUsuario();

        var response = await axios.post("/api/publicacoes/listarPopupLogin", {
          setDB: setDB,
          tipo: tipo,
        });

        var popup =
          response &&
          response.data &&
          response.data.data &&
          response.data.data.dados
            ? response.data.data.dados
            : null;

        if (!popup) return;

        var chave = "popup_visto_" + popup.id;

        var jaViu = this.$cookies.get(chave);

        if (jaViu) return;

        this.popup = popup;
        this.visibleInterno = true;

        this.$cookies.set(chave, "1");
      } catch (err) {
        console.error("Erro ao buscar popup", err);
      }
    },

    fechar() {
      this.visibleInterno = false;
    },
  },
};
</script>

<style>
@media (max-width: 768px) {
  .popup-informativo-dialog {
    width: 94% !important;
    margin-top: 4vh !important;
  }

  .popup-informativo-dialog .el-dialog__body {
    padding: 12px !important;
    overflow-x: hidden !important;
  }

  .popup-informativo-dialog .el-dialog__header {
    padding: 12px 12px 5px !important;
  }

  .popup-informativo-dialog .el-dialog__footer {
    padding: 10px 12px 12px !important;
  }
}
</style>

<style scoped>
.popup-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-word;
  width: 100%;
}

/* força todo conteúdo HTML a respeitar a tela */
.popup-body >>> * {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* imagem responsiva */
.popup-body >>> img {
  display: block !important;
  max-width: 100% !important;
  width: 100% !important;
  height: auto !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

/* textos grandes */
.popup-body >>> h1,
.popup-body >>> h2,
.popup-body >>> h3,
.popup-body >>> p,
.popup-body >>> span,
.popup-body >>> div {
  white-space: normal !important;
  overflow-wrap: break-word !important;
}

/* mobile */
@media (max-width: 768px) {
  .popup-body {
    max-height: 68vh;
    font-size: 14px;
  }

  .popup-body >>> h1 {
    font-size: 22px !important;
    line-height: 1.25 !important;
  }

  .popup-body >>> h2 {
    font-size: 20px !important;
    line-height: 1.25 !important;
  }

  .popup-body >>> img {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
